import { NgModule } from '@angular/core';
import { NgxCaptchaModule } from 'ngx-captcha';
import { RouterModule, Routes } from '@angular/router';
import { VerifySlipNumberComponent } from './modules/open/verify-slip-number/verify-slip-number.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/layout/layout.module').then((m) => m.LayoutModule),
  },
    {
        path: 'negative-market-slip/verify',
        component: VerifySlipNumberComponent,
    },
  {
    path: 'errors',
    loadChildren: () => import('./modules/error/error.module').then((m) => m.ErrorModule),
  },
  { path: '**', redirectTo: 'errors/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes), NgxCaptchaModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
